import React, { FC } from 'react';

import { Icon } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';

import { PromotionType } from 'generated/graphql-gateway';
import { IIncentiveEvaluationResult } from 'state/loyalty/hooks/types';
import { getEvaluationResultMessage } from 'state/loyalty/hooks/utils/helpers';

import {
  IconWrapper,
  IncentiveEvaluationMessagesContainer,
  SingleMessage,
} from './incentive-evaluation-messages.styled';

interface IIncentiveEvaluationMessagesProps {
  className?: string;
  incentiveEvaluationResults: IIncentiveEvaluationResult[];
  hideIcon?: boolean;
}

export const IncentiveEvaluationMessages: FC<IIncentiveEvaluationMessagesProps> = ({
  className = '',
  incentiveEvaluationResults = [],
  hideIcon = false,
}) => {
  const formatters = useIntl();

  return (
    <IncentiveEvaluationMessagesContainer className={className}>
      {incentiveEvaluationResults.map(evaluationResult => {
        const message = getEvaluationResultMessage({
          evaluationResult,
          formatters,
          incentiveType: PromotionType.OFFER,
        });

        return (
          <SingleMessage key={evaluationResult.code}>
            {!hideIcon && (
              <IconWrapper>
                <Icon icon="error" color="text-error" width="24px" aria-hidden />
              </IconWrapper>
            )}
            <span>{message}</span>
          </SingleMessage>
        );
      })}
    </IncentiveEvaluationMessagesContainer>
  );
};
